/* eslint-disable import/prefer-default-export, react/prop-types */
import React from "react";
import Root from "./src/Root";
import Site from "./src/Site";
import { AuthContextProvider } from "./src/components/AuthContext";

export const wrapRootElement = ({ element }, options) => {
	return <Root options={options}>{element}</Root>;
};

export const wrapPageElement = ({ element, props }, options) => {
	return (
		<AuthContextProvider location={props.location}>
			<Site element={element} props={props} options={options} />
		</AuthContextProvider>
	);
};

export const onServiceWorkerUpdateReady = () => {
	const answer = window.confirm(
		`This application has been updated. ` + `Reload to display the latest version?`
	);
	if (answer === true) {
		window.location.reload();
	}
};
